import React from "react";
import { translate } from "../../../../../common/providers";
import styles from "./ProjectDetails.module.css";
import TeamTable from "./project-details-tables/TeamTable";

export default function ProjectDetails({ project = null, companyId }) {
	if (!project) {
		return null;
	}
	const users = Array.isArray(project.users) ? project.users : [];
	return (
		<div className={styles.container}>
			{users.length > 0 ? (
				<TeamTable companyId={companyId} users={users} />
			) : (
				<span className={styles.empty}>{translate("common:empty-state.none")}</span>
			)}
		</div>
	);
}
